import type { TrackingData } from "./TrackingData";
import type { TrackingService } from "../../TrackingService";
import type { DataContainer, Feature, FeatureStatus } from "@otto-ec/tracking-bct";

const PARENT_ID = "FT9-benefit-cinema-bottom";

export class TeaserService {
	constructor(private readonly trackingService: TrackingService) {}

	registerSeenHandler(element: HTMLElement, trackingData: TrackingData) {
		if (window.IntersectionObserver) {
			const observer = new window.IntersectionObserver(
				(e, o) => {
					const entry = e[0];
					if (entry?.isIntersecting) {
						o.unobserve(element);

						const cinemaTracking = this.buildTrackingPayloadCinema("visible", element);
						const benefitTracking = this.buildTrackingPayloadBenefit("visible", trackingData);
						this.trackingService.sendEvent({
							name: "scroll",
							features: [cinemaTracking, benefitTracking],
						});
					}
				},
				{ threshold: 0.75 },
			);
			observer.observe(element);
		}
	}

	initTeaser(container: HTMLElement) {
		const paperCard = container.getElementsByClassName("ft9-benefit-paper-card")[0] as HTMLElement;
		const trackingData = JSON.parse(paperCard.dataset.tracking ?? "") as TrackingData;

		const cinemaTracking = this.buildTrackingPayloadCinema("loaded", container);
		const benefitTracking = this.buildTrackingPayloadBenefit("loaded", trackingData);
		this.trackingService.sendMergeForCinema([cinemaTracking, benefitTracking]);

		this.registerSeenHandler(container, trackingData);
	}

	private buildTrackingPayloadCinema(status: FeatureStatus, teaserRootElement: HTMLElement): Feature {
		const cinemaTrackingLabels = JSON.parse(teaserRootElement.dataset.cinemaTracking ?? "{}") as DataContainer;
		const labels: DataContainer = {
			...cinemaTrackingLabels,
			benefit_Slot: ["footer"],
		};

		return {
			id: PARENT_ID,
			name: "BenefitCinema",
			status,
			labels,
			position: 1,
		};
	}

	private buildTrackingPayloadBenefit(status: FeatureStatus, trackingData: TrackingData) {
		return {
			id: `${trackingData.id}1`,
			name: trackingData.name,
			status,
			labels: trackingData.labels,
			parentId: PARENT_ID,
			position: 1,
		};
	}
}
